import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useConfiguration } from '@travel-frontend/core';
import { Trans, useTranslation } from 'next-i18next';
import { LabelXSmall, Link } from '../../../primitives/index.js';
import { qaId } from '../../../utils/index.js';
import { AUTHENTICATION_QA_ID } from '../../../utils/qaId.js';
export const PolicyInfo = ({
  onTermsOfUseClick,
  onDataProtectionClick
}) => {
  const {
    t
  } = useTranslation('authentication');
  const origin = useConfiguration('origin');
  return _jsx(LabelXSmall, {
    textAlign: "center",
    color: "contentSecondary",
    children: _jsx(Trans, {
      i18nKey: t('signIn.policy'),
      components: [_jsx(Link, {
        "data-testid": qaId(AUTHENTICATION_QA_ID, 'linkTo-termsOfUse'),
        href: `${origin}/service/agb`,
        target: "_blank",
        onClick: onTermsOfUseClick
      }, "termOfUse"), _jsx(Link, {
        onClick: onDataProtectionClick,
        "data-testid": qaId(AUTHENTICATION_QA_ID, 'linkTo-dataProtection'),
        href: `${origin}/service/datenschutz`,
        target: "_blank"
      }, "dataProtection")]
    })
  });
};